var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {Component, Vue} from "vue-property-decorator";
import UiForm, {UiFormController, UiFormAnnotations} from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import API from "@ym-framework/api-utils";
import _ from "lodash";
export class AccountSetupForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.phone = "";
    this.code = "";
    this.phone_code = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801",
    trigger: "blur"
  }, {
    validator: (rule, value, callback) => {
      if (value.search(/^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/) < 0) {
        callback("\u624B\u673A\u53F7\u7801\u683C\u5F0F\u4E0D\u6B63\u786E");
        return false;
      }
      callback();
      return true;
    },
    trigger: "blur"
  }])
], AccountSetupForm.prototype, "phone", 2);
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
    trigger: "blur"
  }])
], AccountSetupForm.prototype, "code", 2);
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: "\u8BF7\u8F93\u5165\u624B\u673A\u9A8C\u8BC1\u7801",
    trigger: "blur"
  }])
], AccountSetupForm.prototype, "phone_code", 2);
let AccountForm = class extends Vue {
  constructor() {
    super(...arguments);
    this.accountsetupController = new AccountSetupForm();
    this.poolCode = [];
    this.countDown = 0;
    this.sendDisabled = false;
    this.getCode = _.debounce(() => __async(this, null, function* () {
      yield this.getPhoneCode();
    }), 800);
    this.SubmitForm = _.debounce(() => __async(this, null, function* () {
      yield this.toSubmit();
    }), 800);
  }
  mounted() {
    return __async(this, null, function* () {
      this.changeCanvas();
    });
  }
  changeCanvas() {
    const c3 = document.getElementById("c3");
    const ctx = c3.getContext("2d");
    ctx.fillStyle = rc(210, 233);
    ctx.fillRect(0, 0, 100, 42);
    let pool = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
    this.poolCode = [];
    for (let i = 0; i < 4; i++) {
      let c = pool[rn(0, pool.length)];
      ctx.textBaseline = "top";
      ctx.fillStyle = rc(80, 180);
      ctx.font = "23px SimHei";
      ctx.fillText(c, i * 25 + 5, 10);
      this.poolCode.push(...c);
    }
    for (let i = 0; i < 5; i++) {
      ctx.strokeStyle = rc(0, 255);
      ctx.beginPath();
      ctx.moveTo(rn(0, 100), rn(0, 42));
      ctx.lineTo(rn(0, 100), rn(0, 42));
      ctx.stroke();
    }
    for (let i = 0; i < 20; i++) {
      ctx.fillStyle = rc(0, 255);
      ctx.beginPath();
      ctx.arc(rn(0, 100), rn(0, 42), 0.5, 0, 2 * Math.PI);
      ctx.fill();
    }
    function rc(min, max) {
      let r = rn(min, max);
      let g = rn(min, max);
      let b = rn(min, max);
      return `rgb(${r},${g},${b})`;
    }
    function rn(min, max) {
      let n = Math.random() * (max - min) + min;
      return Math.floor(n);
    }
  }
  getPhoneCode() {
    return __async(this, null, function* () {
      try {
        if (this.accountsetupController.phone === null || this.accountsetupController.phone === "") {
          return this.$message.error("\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801");
        }
        if (!/^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/.test(this.accountsetupController.phone)) {
          return;
        }
        if (this.accountsetupController.code === null || this.accountsetupController.code === "") {
          return this.$message.error("\u8BF7\u5148\u8F93\u5165\u9A8C\u8BC1\u7801");
        }
        let codeStr = this.poolCode.join("");
        if (this.accountsetupController.code !== codeStr) {
          this.changeCanvas();
          return this.$message.error("\u60A8\u8F93\u5165\u7684\u9A8C\u8BC1\u7801\u4E0D\u6B63\u786E,\u8BF7\u91CD\u8BD5");
        }
        yield API.post(`api://base/api/v6/certification/verify_code/send`, {
          "code_type": 7,
          "phone": this.accountsetupController.phone
        });
        this.countDown = 60;
        let btn = document.getElementById("sendCode");
        this.setupTime(btn);
      } catch (error) {
        this.changeCanvas();
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  setupTime(btn) {
    btn.style.color = "#ccc";
    if (this.countDown === 0) {
      this.sendDisabled = false;
      btn.innerHTML = "\u91CD\u65B0\u53D1\u9001";
      this.countDown = 60;
      btn.style.color = "#35d2ad";
      return;
    } else {
      this.sendDisabled = true;
      btn.innerHTML = this.countDown.toString();
      btn.style.color = "#ccc";
      this.countDown--;
    }
    setTimeout(() => {
      this.setupTime(btn);
    }, 1e3);
  }
  toSubmit() {
    return __async(this, null, function* () {
      try {
        let codeStr = this.poolCode.join("");
        if (this.accountsetupController.code !== codeStr) {
          this.changeCanvas();
          return this.$message.error("\u60A8\u8F93\u5165\u7684\u9A8C\u8BC1\u7801\u4E0D\u6B63\u786E,\u8BF7\u91CD\u8BD5");
        }
        let response = yield API.post(`api://base/api/v6/certification/verify_code/check`, {
          "code_type": 7,
          "phone": this.accountsetupController.phone,
          "verify_code": this.accountsetupController.phone_code
        });
        localStorage.setItem("authenticationToken", response.data.auth_token);
        localStorage.setItem("userName", response.data.account_name);
        this.$emit("toLogin");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
AccountForm = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit
    }
  })
], AccountForm);
export default AccountForm;
